import balanceAdjustments from '@/locales/en/accounting/balanceAdjustments.locales';
import externalProviders from '@/locales/en/accounting/externalProviders.locales';
import payments from '@/locales/en/accounting/payments.locales';
import providerPaymentPeriods from '@/locales/en/accounting/providerPaymentPeriods.locales';

export default {
    ...balanceAdjustments,
    ...payments,
    ...externalProviders,
    ...providerPaymentPeriods,
};
